// French for the client library: verbs, folder chips, the table and the librarian's toasts.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Documents enter the library through an engagement — create one first.': 'Les documents entrent dans la bibliothèque via un mandat — créez-en un d’abord.',
  '{n} added to the library': '{n} ajouté(s) à la bibliothèque',
  '{n} already on file': '{n} déjà enregistré(s)',
  '{n} not accepted': '{n} non accepté(s)',
  'Librarian finished — {n} document(s) classified': 'Bibliothécaire terminé — {n} document(s) classifié(s)',
  'the': 'les',
  'Librarian finished — the library is filed.': 'Bibliothécaire terminé — la bibliothèque est classée.',
  'The librarian is not installed yet — classification arrives with the next release.': 'Le bibliothécaire n’est pas encore installé — la classification arrive avec la prochaine version.',
  'Library': 'Bibliothèque',
  'Classify every document — folder, tags, one-line summary. Auto-applied, always yours to correct.': 'Classifier chaque document — dossier, tags, résumé en une ligne. Appliqué automatiquement, toujours modifiable par vous.',
  'Classifying…': 'Classification en cours…',
  'Run librarian': 'Lancer le bibliothécaire',
  'New uploads enter the library through this engagement': 'Les nouveaux téléversements entrent dans la bibliothèque via ce mandat',
  'via {code}': 'via {code}',
  'Add files to the client library': 'Ajouter des fichiers à la bibliothèque client',
  'Documents enter the library through an engagement — create one first': 'Les documents entrent dans la bibliothèque via un mandat — créez-en un d’abord',
  'Uploading…': 'Téléversement en cours…',
  'Upload': 'Téléverser',
  'All': 'Tous',
  'unclassified': 'non classifié',
  'No documents match this filter': 'Aucun document ne correspond à ce filtre',
  'The library is empty': 'La bibliothèque est vide',
  'Pick another folder, or All.': 'Choisissez un autre dossier, ou «Tous».',
  'Upload here, or ingest on the Documents page of an engagement — everything lands in this library.': 'Téléversez ici, ou ingérez sur la page Documents d’un mandat — tout atterrit dans cette bibliothèque.',
  'Ref': 'Réf',
  'Document': 'Document',
  'Folder': 'Dossier',
  'Used by': 'Utilisé par',
  'Evidence citations across all engagements': 'Citations de preuves sur tous les mandats',
  '{n}× cited': '{n}× cité',
  'library only': 'bibliothèque uniquement',
  'uploaded here': 'téléversé ici',
  'linked from library': 'lié depuis la bibliothèque',
  // document status badges (r.status)
  'processing': 'en traitement',
  'ready': 'prêt',
  'failed': 'échoué',
  'superseded': 'remplacé',
  // DOCUMENT_FOLDERS — the folder chips
  'correspondence': 'correspondance',
  'meeting': 'réunion',
  'agreement': 'accord',
  'financial': 'finances',
  'specification': 'spécification',
  'presentation': 'présentation',
  'image': 'image',
  'note': 'note',
  'deliverable': 'livrable',
  'reference': 'référence',
}, 'ClientLibrary');
